<template>
  <generic-modal
    size="small"
    :title="$t('code request')"
    icon="barcode"
    image="/images/icons/nvidia-round.jpeg"
    :show_ok="true"
    :scrolling="false"
    v-on:destroy="$emit('close')"
    :on_finished="on_finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="field">
          <label for="">{{ $t("customer name") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="customer_name"
              v-model="setup.customer_name"
            />
            <i class="users icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("customer email") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="customer_email"
              v-model="setup.customer_email"
            />
            <i class="at icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("ticket or bill number") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="ticket_bill_number"
              v-model="setup.ticket_bill_number"
            />
            <i class="users icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("product type") }}</label>
          <div class="ui selection dropdown" ref="product_dropdown">
            <input type="hidden" name="product_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("gpu type") }}</label>
          <div class="ui selection dropdown" ref="gpu_dropdown">
            <input type="hidden" name="gpu_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("brand") }}</label>
          <div class="ui selection dropdown" ref="brand_dropdown">
            <input type="hidden" name="brand" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("card or notebook serial number") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="ticket_bill_number"
              v-model="setup.card_notebook_serial"
            />
            <i class="users icon"></i>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { local_api /* error_toast */ } from "@/utils";
import filters from "@/filters";

export default {
  name: "NvidiaTicketRequestModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  props: { configuration: Object },
  data() {
    return {
      id: "",
      setup: {
        customer_name: "",
        customer_email: "",
        ticket_bill_number: "",
        product_type: "",
        gpu_type: "",
        brand: "",
        card_notebook_serial: "",
      },
    };
  },
  methods: {
    on_finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/nvidia_ticket/request/do-save", {
          setup: vm.setup,
          ri: vm.id,
        })
          .then(function(r) {
            resolve(r);
            vm.$emit("succedded", vm.setup);
          })
          .catch(function(err) {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    let product_types = vm.configuration.product_types.map((t) => {
      return { name: vm.$t(t), value: t };
    }); /*[
      {
        name: vm.$t("desktop"),
        value: "desktop",
      },
      {
        name: vm.$t("laptop"),
        value: "laptop",
      },
      {
        name: vm.$t("card"),
        value: "card",
      },
    ]; */
    let gpu_types = vm.configuration.cards.map((c) => {
      return { name: c.setup.name, value: c.graphic_card_id };
    }); /* [
      {
        name: vm.$t("desktop"),
        value: "desktop",
      },
      {
        name: vm.$t("laptop"),
        value: "laptop",
      },
      {
        name: vm.$t("card"),
        value: "card",
      },
    ]; */
    let brands =
      vm.configuration
        .brands; /* [
      {
        name: vm.$t("desktop"),
        value: "desktop",
      },
      {
        name: vm.$t("laptop"),
        value: "laptop",
      },
      {
        name: vm.$t("card"),
        value: "card",
      },
    ]; */

    window
      .jQuery(vm.$refs.product_dropdown)
      .dropdown("setup menu", { values: product_types });
    window
      .jQuery(vm.$refs.gpu_dropdown)
      .dropdown("setup menu", { values: gpu_types });
    window
      .jQuery(vm.$refs.brand_dropdown)
      .dropdown("setup menu", { values: brands });
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
